import React, { useEffect, useState } from 'react';
import { UI } from '../theme';
import PawIcon from './PawIcon';

const HomeI = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 11l9-8 9 8v10a2 2 0 01-2 2h-4v-7h-6v7H5a2 2 0 01-2-2V11z"/></svg>
);
const MapI = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 4l-6 2v14l6-2 6 2 6-2V4l-6 2-6-2zM9 4v14M15 6v14"/></svg>
);
const MeI = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 21c0-4 4-7 8-7s8 3 8 7"/></svg>
);

export default function BottomNav({ active, onNav, theme, onFab }) {
  const [isDesktop, setIsDesktop] = useState(() => typeof window !== 'undefined' ? window.innerWidth >= 1024 : false);
  useEffect(() => {
    const onResize = () => setIsDesktop(window.innerWidth >= 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const items = [
    { id: 'home', label: 'หน้าแรก', icon: <HomeI/> },
    { id: 'map', label: 'แผนที่', icon: <MapI/> },
    { id: 'fab' },
    { id: 'community', label: 'ชุมชน', icon: <PawIcon size={22}/> },
    { id: 'me', label: 'ฉัน', icon: <MeI/> },
  ];
  const navText = theme.navText || theme.text;
  const navMuted = theme.navMuted || theme.muted;
  const navActiveBg = theme.navActiveBg || `${theme.primary}18`;
  const shellWidth = isDesktop ? 'min(520px, calc(100vw - 48px))' : 'min(520px, calc(100vw - 24px))';
  const navItemWidth = isDesktop ? 64 : 'clamp(50px, 17vw, 64px)';
  const fabSize = isDesktop ? 56 : 'clamp(50px, 15vw, 56px)';

  return (
    <div data-testid="v2-bottom-nav" className="tl-v2-bottomnav" style={{
      position: 'fixed',
      bottom: isDesktop ? 18 : 'max(12px, env(safe-area-inset-bottom))',
      left: '50%',
      right: 'auto',
      transform: 'translateX(-50%)',
      zIndex: 40,
      width: shellWidth,
      borderRadius: 999,
      background: theme.navBg,
      backdropFilter: 'blur(20px) saturate(180%)',
      WebkitBackdropFilter: 'blur(20px) saturate(180%)',
      border: `1.5px solid ${theme.navBorder}`,
      boxShadow: isDesktop ? theme.shadow : '0 14px 36px -16px rgba(20,26,38,0.42), 0 4px 16px rgba(20,26,38,0.12)',
      overflow: 'visible',
    }}>
      <div style={{
        width: '100%', margin: '0 auto',
        display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'relative',
        padding: isDesktop ? '4px 8px' : '4px clamp(6px, 2vw, 8px)',
        boxSizing: 'border-box',
      }}>
        {items.map(it => {
          if (it.id === 'fab') {
            return (
              <button
                key="fab"
                data-testid="v2-bottomnav-fab"
                onClick={onFab}
                style={{
                  width: fabSize, height: fabSize, borderRadius: '50%',
                  background: `linear-gradient(135deg, ${theme.sunsetA}, ${theme.sunsetB})`,
                  border: `2px solid ${theme.surface}`, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  boxShadow: `0 10px 24px -4px ${theme.primary}99`,
                  marginTop: isDesktop ? -28 : -24, color: '#fff', flexShrink: 0,
                }}
              >
                <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
              </button>
            );
          }
          const isActive = active === it.id;
          return (
            <button
              key={it.id}
              data-testid={`v2-bottomnav-${it.id}`}
              onClick={() => onNav(it.id)}
              style={{
                width: navItemWidth, minHeight: isDesktop ? 52 : 50, padding: '6px 0', border: `1px solid ${isActive ? theme.navBorder : 'transparent'}`,
                borderRadius: 18, background: isActive ? navActiveBg : 'transparent', cursor: 'pointer', flexShrink: 1,
                color: isActive ? theme.primary : navMuted,
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2,
                fontFamily: UI, fontSize: 10, fontWeight: isActive ? 900 : 750,
                textShadow: isActive ? 'none' : '0 1px 0 rgba(255,255,255,0.04)',
              }}
            >
              {it.icon}
              <span style={{ color: isActive ? theme.primary : navText, opacity: isActive ? 1 : 0.86, whiteSpace: 'nowrap', lineHeight: 1.1 }}>{it.label}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
